(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    function (e) {
      if (!e.target.classList.contains('filter-disclosure') && !e.target.classList.contains('sort-disclosure')) return;

      if (e.target.open) {
        document.body.setAttribute('data-scroll-locked', '');
      } else {
        // Unlock scroll only if no other filter is still open
        if (!document.querySelector('.filter-disclosure[open], .sort-disclosure[open]')) {
          document.body.removeAttribute('data-scroll-locked');
        }
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-localization"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-mobile-localization]');
    if (!root) return;

    var details = root.querySelector('.mobile-localization__details');
    var form = root.querySelector('form');
    if (!details || !form) return;

    var hiddenInput = form.querySelector('input[name="country_code"]');
    var optionButtons = form.querySelectorAll('.mobile-localization__option');
    var closeButton = root.querySelector('.mobile-localization__close');

    function submitWithTransition() {
      if (!hiddenInput.value) return;

      if (document.startViewTransition) {
        document.startViewTransition(function () {
          HTMLFormElement.prototype.submit.call(form);
        });
      } else {
        HTMLFormElement.prototype.submit.call(form);
      }
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        var countryCode = event.currentTarget.getAttribute('data-country-code');
        if (!countryCode) return;

        hiddenInput.value = countryCode;
        submitWithTransition();
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        details.removeAttribute('open');
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
